import { render } from "./my-profile.vue?vue&type=template&id=68e2b8cb"
import script from "./my-profile.vue?vue&type=script&lang=ts"
export * from "./my-profile.vue?vue&type=script&lang=ts"
script.render = render

export default script